export const getFilteredCountry = (countries, countryUrl) => countries.find((item) => item.url === countryUrl || item.countryUrl === countryUrl);
